package com.zaurh.resume.ui.theme

import androidx.compose.ui.graphics.Color

sealed class ThemeColors(
    val surface: Color,
    val background: Color,
    val text: Color,
    val neon: Color,
    val textField: Color
) {
    object Night : ThemeColors(
        surface = Color(0xFF2A2A38),
        background = Color(0xFF25233D),
        text = Color.White,
        textField = Color.White,
        neon = Color.Cyan
    )

    object Day : ThemeColors(
        surface = Color(0xFFEBFFF9),
        background = Color(0xFFFFFFFF),
        text = Color(0xFF070420),
        textField = Color(0xFF5A5A5A),
        neon = Color(0xFF6B57FF)
    )
}